module.exports = __webpack_public_path__ + "static/media/Servicos1.c29cadf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/CadServicos/Servicos1.png
// module id = 2115
// module chunks = 0